import { TabsWithUnderline } from "@truevault/aquilo";
import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../root/routes";

export type RequestWorkflowTab =
  | "consumer-lookup"
  | "request-to-delete"
  | "request-to-opt-out"
  | "access-request"
  | "request-to-profiling-opt-out"
  | "request-to-limit";

const TABS_CONFIG: { tabKey: string; name: string; route: string }[] = [
  {
    name: "Consumer Lookup",
    route: Routes.organization.requestHandling.consumerGroup,
    tabKey: "consumer-lookup",
  },
  {
    name: "Request to Delete",
    route: Routes.organization.requestHandling.requestToDelete,
    tabKey: "request-to-delete",
  },
  {
    name: "Request to Opt-Out",
    route: Routes.organization.requestHandling.requestToOptOut,
    tabKey: "request-to-opt-out",
  },
  {
    name: "Access Request",
    route: Routes.organization.requestHandling.accessRequest,
    tabKey: "access-request",
  },
  {
    name: "Request to Limit",
    route: Routes.organization.requestHandling.requestToLimit,
    tabKey: "request-to-limit",
  },
  {
    name: "Profiling Opt-Out",
    route: Routes.organization.requestHandling.requestToProfilingOptOut,
    tabKey: "request-to-profiling-opt-out",
  },
];

export function StepNumberCircle({ text }: { text: string }) {
  return (
    <div className="h-[28px] w-[28px] text-center rounded-[100px] bg-primary-100 text-primary-600 font-bold text-lg">
      {text}
    </div>
  );
}

export function WorkflowSetupTabs({
  selectedTabKey,
  enableNextTab = true,
  enableAllTabs = true,
  isLimitStepIncomplete = false,
}: {
  selectedTabKey: RequestWorkflowTab;
  enableNextTab?: boolean; // whether the tab immediate to the right of the current tab should be enabled
  enableAllTabs?: boolean; // whether all tabs should be enabled
  isLimitStepIncomplete?: boolean;
}) {
  const history = useHistory();

  let selectedTabIdx = TABS_CONFIG.findIndex((tabConfig) => tabConfig.tabKey === selectedTabKey);

  const tabs = (
    <TabsWithUnderline
      tabs={TABS_CONFIG.map((tabConfig, idx) => {
        // `tab` is enabled if (1) it is the current tab, (2) before the current tab, (3) it is the next tab and `enableNextTab` is true, or (4) `enableAllTabs` is true
        let enabled = false;
        if (tabConfig.tabKey === selectedTabKey) {
          enabled = true;
        } else if (idx < selectedTabIdx) {
          enabled = true;
        } else if (idx === selectedTabIdx + 1 && enableNextTab) {
          enabled = true;
        } else if (enableAllTabs) {
          enabled = true;
        }

        let showIncompleteIndicator = false;
        if (tabConfig.tabKey === "request-to-limit" && isLimitStepIncomplete === true) {
          showIncompleteIndicator = true;
        }

        return {
          name: tabConfig.name,
          current: tabConfig.tabKey === selectedTabKey,
          onClick: () => {
            if (enabled) {
              history.push(tabConfig.route);
            }
          },
          disabled: !enabled,
          showIncompleteIndicator,
        };
      })}
    />
  );

  return <div className="tw-boundary">{tabs}</div>;
}
